<form class="create-customer-form" [formGroup]="cf" (keydown.enter)="enterClicked.emit($event)">
  <app-pre *ngIf="0" [obj]="cf.value" />
  <div class="company-form-fields-container">
    <app-form-input controlKey="name" labelT="customer-spaces.create-customer-form.company" />
    <app-form-input controlKey="erpAddressNumber" labelT="customer-spaces.create-customer-form.erp-address-number" />
    <app-form-input controlKey="erpProjectNumber1" labelT="customer-spaces.create-customer-form.erp-project-number" />
    <app-form-input controlKey="erpProjectNumber2" [labelT]="erpProjectNumber2Label()" />
    <app-form-select controlKey="abacusInstanceId" [items]="(abacusInstances$ | async)!"
      labelT="customer-spaces.create-customer-form.abacus-instance" />
    <app-form-input controlKey="abacusMandatorId" labelT="customer-spaces.create-customer-form.abacus-mandator" />

    <app-form-input *ngIf="cf.get('erpProjectNumber2')!.value !== '' || cf.get('erpProjectNumber3')!.value !== ''"
      controlKey="erpProjectNumber3" [labelT]="erpProjectNumber3Label()" />
    <app-form-input *ngIf="cf.get('erpProjectNumber3')!.value !== '' || cf.get('erpProjectNumber4')!.value !== ''"
      controlKey="erpProjectNumber4" [labelT]="erpProjectNumber4Label()" />
  </div>

  <div class="form-row">

    <app-form-button-toggle *ngIf="!!customerSpaceId" controlKey="status" class="button-toggle-container"
      labelT="customer-spaces.create-customer-form.status" [value1]="'Active'" label1T="customer-spaces.status.active"
      [value2]="'Inactive'" label2T="customer-spaces.status.inactive" />

    <app-form-toggle controlKey="isTermsUpdateRequired" class="color-primary-when-toggle-disabled"
      labelT="customer-spaces.create-customer-form.is-terms-update-required" />

    <div class="deactivation-comment">
      <mat-form-field class="comment-input" color="accent" *ngIf="isInactiveSelected()">
        <mat-label>{{ 'customer-spaces.create-customer-form.deactivation-comment' | translate }}</mat-label>
        <textarea matInput formControlName="deactivationComment" rows="3"></textarea>
        <mat-error *ngIf="cf.get('deactivationComment')!.hasError('deactivationCommentRequired')">
          {{ 'customer-spaces.create-customer-form.error.deactivation-comment-mandatory' | translate }}
        </mat-error>
      </mat-form-field>
      <div class="deactivated-by" *ngIf="isInactiveSelected()">{{ deactivatedBy }} {{ deactivationTime | date:
        'dd.MM.yyyy HH:mm' }}</div>
    </div>
  </div>
  <div class="form-row mt-30">
    <app-form-button-toggle controlKey="isActiveForExternal"
      labelT="customer-spaces.create-customer-form.is-active-for-external" [value1]="true" label1T="shared.yes"
      [value2]="false" label2T="shared.no" />
  </div>
</form>